import { useState } from 'react'

import { Box, Button, Icon, Text } from '@factorialco/deprecated-design-system'
import { AvailableModules, Features } from 'generated/featureDefinitions'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import RequestUpgradeModal from 'modules/upsell/components/RequestUpgradeModal'
import { ValidReasons } from 'modules/upsell/hooks/useCreateUpsellRequest'

export const Upgrade = () => {
  const {
    company: { subscription },
  } = useCurrentSession()

  const [openUpgradeModal, setOpenUpgradeModal] = useState<boolean>(false)
  const [alreadySuccess, setAlreadySuccess] = useState<boolean>(false)

  const onClose = () => {
    if (alreadySuccess) {
      setOpenUpgradeModal(false)
      return
    }

    track(trackingEvents.projectManagement.projectLog.upsell.cancelUpsell)
    setOpenUpgradeModal(false)
  }

  const onSuccess = () => {
    track(trackingEvents.projectManagement.projectLog.upsell.confirmUpsell)
    setAlreadySuccess(true)
    setOpenUpgradeModal(false)
  }

  return (
    <>
      <Box width="full" alignItems="center" justifyContent="center" position="fixed" height="full">
        <Box
          alignItems="center"
          width="s360"
          textAlign="center"
          padding="s24"
          gap="s16"
          paddingBottom="s96"
        >
          <Icon.Large icon="fireworks" color="grey700" />
          <Text.Normal weight="medium" color="grey1000">
            {i18n.t('project_management.project_log.upsell.title')}
          </Text.Normal>
          <Text.Normal>{i18n.t('project_management.project_log.upsell.description')}</Text.Normal>
          <Button onClick={() => setOpenUpgradeModal(true)} type="upgrade">
            {i18n.t('project_management.project_log.upsell.button')}
          </Button>
        </Box>
      </Box>

      {openUpgradeModal && (
        <RequestUpgradeModal
          requestReason={
            subscription.isPre2022Legacy
              ? ValidReasons.MissingFeatureLegacy
              : ValidReasons.MissingFeature
          }
          featureRequested={Features.projects_logs}
          requestSource="Project Management Log"
          title={i18n.t('project_management.project_log.upsell.modal.title')}
          description={i18n.t('project_management.project_log.upsell.modal.description')}
          moduleRequested={AvailableModules.projects}
          onClose={onClose}
          onSuccess={onSuccess}
        />
      )}
    </>
  )
}
